import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/dashboard'
import { dashboardKeys } from '@core/react-query/features/dashboard'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IPermitStats, PermitStats } from '@core/entities/dashboard/permitStats'

const dataTransformer = (permitStats: IPermitStats) =>
  PermitStats.new(permitStats)

export const useGetDashboardPermitStats = (
  payload: RequestTypes['getDashboardPermitStats'],
  options?: UseQueryOptions<IPermitStats, RequestErrorType, PermitStats>,
) => {
  return useQuery({
    select: dataTransformer,
    ...dashboardKeys.getDashboardPermitStats(payload),
    ...options,
  })
}
